import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import { IListPrice, IListPriceInput } from "@/interfaces/list-price.interface";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class ListPriceService {
  private baseUrl = "api/v1/listprice";

  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<IListPrice>> {
    const paginationQuery = buildPaginationQuery(pagination);
    const listPrices = await httpRequest.get(`${this.baseUrl}?${paginationQuery}`);
    return listPrices;
  }

  async filter(
    filter: IFilter<IListPrice>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<IListPrice>> {
    const paginationQuery = buildPaginationQuery(pagination);

    const response = await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, {
      filter,
    });

    return response;
  }

  async update(formData: IListPriceInput, listPriceId: number): Promise<void> {
    await httpRequest.put(`${this.baseUrl}/${listPriceId}`, formData);
  }

  async getById(listPriceId: number): Promise<IListPrice> {
    const listPrice = await httpRequest.get(`${this.baseUrl}/${listPriceId}`);

    return listPrice;
  }
}

const listPriceService = new ListPriceService();
export { listPriceService };
